// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { Stack, useMediaQuery, useTheme } from "@mui/material";
import { Table, createBooleanOperator } from "../molecules";
import { GridColDef, GridPaginationModel } from "@mui/x-data-grid";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useGetMerchantPaymentDetail } from "../../hooks";
import { default as dayjs } from "dayjs";
import { downloadExcel } from "../../util/downloadExcel";

export function MechantPaymentModal({ transaction, isOpen, handleClose }) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [queryOptions, setQueryOptions] = React.useState({});
  const [tableData, setTableData] = useState([]);
  const {
    mutate: GetMerchantPaymentDetail,
    isLoading: isGetMerchantPaymentDetailLoading,
  } = useGetMerchantPaymentDetail();
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 10,
  });

  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel(model);
    const req: GetMerchantPaymenDetailtRequest = {
      date: getValues("startDate")
        ? dayjs(getValues("startDate")).format("YYYY-MM-DD HH:mm:ss")
        : "",
      orderId: getValues("orderId"),
      cardNumber: getValues("cardNumber"),
      authCode: getValues("authCode"),
      status: getValues("status"),
      transactionType: getValues("transactionType"),
      bankCode: getValues("bankCode"),
      size: paginationModel.pageSize,
      page: paginationModel.page,
      orderBy: "CreateDate",
    };

    GetMerchantPaymentDetail(req, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setTableData(data.data);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  };
  const booleanOptions = [
    { label: "Evet", value: true },
    { label: "Hayır", value: "false" },
  ];
  const currencyDesc = [
    { label: "TRY", value: "TRY" },
    { label: "USD", value: "USD" },
    { label: "EUR", value: "EUR" }
  ];
  const columns: GridColDef[] = useMemo(() => {
    return [
      { field: "merchantId", headerName: "Üye İşyeri Numarası", width: 180 },
      {
        field: "amount", headerName: "Tutar", width: 120, type: 'decimal', valueFormatter: (params: GridValueFormatterParams<number>) =>
          `${params.value} TL`,
      },
      { field: "installmentCount", headerName: "Taksit Sayısı", width: 150 },
      { field: "authCode", headerName: "Onay Kodu", width: 150 },
      {
        field: "endOfDayDate", headerName: "Gün Sonu Tarihi", width: 150, renderCell: (params) => {
          if (!params.value) return ""; // Eğer değer null veya undefined ise boş döndür
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
          if (formattedDate === "Invalid Date") return ""; // Eğer dönüşüm sonucu "Invalid Date" ise boş döndür
          return formattedDate;
        }
      },
      {
        field: "bankAmount", headerName: "Banka Tutarı", width: 150, type: 'decimal',
        valueFormatter: (params: GridValueFormatterParams<number>) =>
          `${params.value} TL`,
      },
      { field: "bankCode", headerName: "Banka Kodu", width: 120 },
      {
        field: "bankCommissionAmount",
        headerName: "Banka Komisyon Tutarı",
        width: 200,
        type: 'decimal',
        valueFormatter: (params: GridValueFormatterParams<number>) =>
          `${params.value} TL`,
      },
      { field: "bankName", headerName: "Banka Adı", width: 180 },
      {
        field: "bankblocked",
        headerName: "Banka Blokesi Var mı?",
        width: 180,
        renderCell: (params) => {
          return params.value ? "Evet" : params.value !== null && params.value !== undefined ? "Hayır" : " ";
        },
        filterOperators: [createBooleanOperator(booleanOptions)],
      },
      {
        field: "bankblockedday",
        headerName: "Banka Bloke Gün Sayısı",
        width: 200,
      },
      { field: "cardHolderName", headerName: "Kart Sahibi Adı", width: 180 },
      { field: "cardType", headerName: "Kart Türü", width: 120 },
      { field: "currency", headerName: "Para Birimi", width: 150 },
      {
        field: "customerCommissionAmount",
        headerName: "Müşteri Komisyon Tutarı",
        width: 200,
        type: "decimal",
        valueFormatter: (params: GridValueFormatterParams<number>) =>
          `${params.value} TL`,
      },
      {
        field: "paymentMerchantDate", headerName: "Üye İşyeri Ödeme Tarihi", width: 200, renderCell: (params) => {
          if (!params.value) return ""; // Eğer değer null veya undefined ise boş döndür
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
          if (formattedDate === "Invalid Date") return ""; // Eğer dönüşüm sonucu "Invalid Date" ise boş döndür
          return formattedDate;
        }
      },
      { field: "maskedPan", headerName: "Maskeleme Pan", width: 180 },
      {
        field: "merchantAmount", headerName: "İşyeri Tutarı", width: 150, type: 'decimal', valueFormatter: (params: GridValueFormatterParams<number>) =>
          `${params.value} TL`,
      },
      {
        field: "merchantCommisionAmount",
        headerName: "İşyeri Komisyon Tutarı",
        width: 200,
        type: 'decimal',
        valueFormatter: (params: GridValueFormatterParams<number>) =>
          `${params.value} TL`,
      },
      { field: "merchantName", headerName: "İşyeri Adı", width: 180 },
      {
        field: "merchantblocked",
        headerName: " İşyeri Blokesi ",
        width: 180,
        renderCell: (params) => {
          return params.value ? "Evet" : params.value !== null && params.value !== undefined ? "Hayır" : " ";
        },
        filterOperators: [createBooleanOperator(booleanOptions)],
      },
      {
        field: "merchantblockedday",
        headerName: "İşyeri Bloke Gün Sayısı",
        width: 200,
      },
      {
        field: "paymentFlag",
        headerName: "Ödeme Yapıldı Mı?",
        width: 150,
        renderCell: (params) => {
          return params.value ? "Evet" : params.value !== null && params.value !== undefined ? "Hayır" : " ";
        },
        filterOperators: [createBooleanOperator(booleanOptions)],
      },
      {
        field: "revenue", headerName: "AHL Pay Kar", width: 120, type: 'decimal', valueFormatter: (params: GridValueFormatterParams<number>) =>
          `${params.value} TL`,
      },
      {
        field: "totalAmount", headerName: "Toplam Tutar", width: 150, type: 'decimal', valueFormatter: (params: GridValueFormatterParams<number>) =>
          `${params.value} TL`,
      },
      { field: "transactionDate", headerName: "İşlem Tarihi", width: 150 },
      { field: "txnTypeDesc", headerName: "İşlem Türü", width: 120 },
    ];
  }, []);

  useEffect(() => {
    if (isOpen && transaction) {
      const requestPayload = {
        merchantId: transaction.merchantId, date: transaction.paymentMerchantDate,
        ...getQueryParams(queryOptions),
      };

      if (queryOptions?.field && queryOptions?.value !== undefined) {
        requestPayload[queryOptions.field] = queryOptions.value;
      }
      GetMerchantPaymentDetail(
        requestPayload,
        {
          onSuccess: (data) => {
            if (data.isSuccess) {
              setTableData(data.data);
              setSnackbar({
                severity: "success",
                isOpen: true,
                description: data.message,
              });
            } else {
              setSnackbar({
                severity: "error",
                description: data.message,
                isOpen: true,
              });
            }
          },
          onError: () => {
            setSnackbar({
              severity: "error",
              description: "İşlem sırasında bir hata oluştu",
              isOpen: true,
            });
          },
        }
      );
    }
  }, [isOpen, transaction, queryOptions,]);

  const onSave = () => {

    const requestPayload = {
      size: -1,
      page: 0,
      orderBy: "CreateDate",
      orderByDesc: true,
      merchantId: transaction?.merchantId,
      date: dayjs(transaction?.paymentMerchantDate).format("YYYY-MM-DD"),
      ...getQueryParams(queryOptions),
    };

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }

    GetMerchantPaymentDetail(
      requestPayload
      ,
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            function fieldValue(data) {
              return data.map((item) => {
                return {
                  "Üye İşyeri Numarası": item?.merchantId || " ",
                  "Tutar": item?.amount || " ",
                  "Taksit Sayısı": item?.installmentCount || " ",
                  "Onay Kodu": item?.authCode || " ",
                  "Üye İşyeri Ödeme Tarihi": item?.paymentMerchantDate || "",
                  "Banka Tutarı": item?.bankAmount || " ",
                  "Banka Kodu": item?.bankCode || " ",
                  "Banka Komisyon Tutarı": item?.bankCommissionAmount || " ",
                  "Banka Adı": item?.bankName || " ",
                  "Banka Blokesi Var mı?": item?.bankblocked !== undefined && item?.bankblocked !== null ? (item?.bankblocked ? "Evet" : "Hayır") : " ",
                  "Banka Bloke Gün Sayısı ": item?.bankblockedday || " ",
                  "Kart Sahibi Adı": item?.cardHolderName || " ",
                  "Kart Türü": item?.cardType,
                  "Para Birimi": item?.currency || " ",
                  "Müşteri Komisyon Tutarı": item?.customerCommissionAmount || " ",
                  "Gün Sonu Tarihi": item?.endOfDayDate || " ",
                  "Maskeleme Pan": item?.maskedPan || " ",
                  "İşyeri Tutarı": item?.merchantAmount || " ",
                  "İşyeri Komisyon Tutarı": item?.merchantCommisionAmount || " ",
                  "İşyeri Adı": item?.merchantName || " ",
                  " İşyeri Blokesi ": item?.merchantblocked !== undefined && item?.merchantblocked !== null ? (item?.merchantblocked ? "Evet" : "Hayır") : " ",
                  "İşyeri Bloke Gün Sayısı": item?.merchantblockedday || " ",
                  "Ödeme Yapıldı Mı?": item?.paymentFlag !== undefined && item?.paymentFlag !== null ? (item?.paymentFlag ? "Evet" : "Hayır") : " ",
                  "AHL Pay Kar": item?.revenue || " ",
                  "Toplam Tutar": item?.totalAmount || " ",
                  "İşlem Tarihi": item?.transactionDate || " ",
                  "İşlem Türü": item?.txnType || " "

                };
              });
            }
            const refactoredData = fieldValue(data?.data);
            downloadExcel(
              refactoredData || [], "İşyeri Hak Ediş Raporları Detay"
            );
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          console.log(error);
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  const getQueryParams = (filters) => {
    const queryParams = {};

    for (let key in filters) {
      let value = filters[key];
      // Eğer gelen değer string "false" ise onu boolean false'a çevir
      if (value === "false") {
        queryParams[key] = false;
      } else {
        if (value !== null && value !== undefined && value.toString().length > 0) {
          queryParams[key] = value;
        }
      }
    }
    return queryParams;
  };

  const handleFilterChange = debounce((filters) => {
    if (filters.clearFilter) {
      return setQueryOptions({});
    }
    const queryParams = getQueryParams(filters);

    const isValueValid = (key, value) => {
      if (key === 'installmentCount' || key === 'cardType') { // Özel alan kontrolü
        return value?.toString().length >= 1;
      } else {
        return value?.toString().length >= 3;
      }
    }


    const allValuesValid = Object.entries(queryParams).every(([key, value]) => isValueValid(key, value));

    const previousKeysLength = Object.keys(previousQueryParams.current).length;
    const currentKeysLength = Object.keys(queryParams).length;

    // Eğer queryParams bir önceki ile aynıysa işlem yapma
    if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
      return;
    }

    if (allValuesValid || (previousKeysLength > currentKeysLength)) {
      setQueryOptions(queryParams);
    }


    // Son olarak, mevcut queryParams değerini bir önceki değer olarak set edin
    previousQueryParams.current = queryParams;

  }, 500);
  const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;
  // Komponent içerisinde
  const previousQueryParams = React.useRef({});

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: isDesktop ? 1300 : isSmallScreen ? "90%" : "70%",
          maxHeight: '90vh',  // eklenen satır
          maxWidth: '90vw',  // eklenen satır
          overflow: 'auto',  // eklenen satır
          bgcolor: "background.paper",
          border: "2px solid #2196f3",
          boxShadow: 24,
          p: 4,
          display: "relative",
        }}
      >
        <h2 id="modal-modal-title">İşyeri Hak Ediş Raporları Detay</h2>

        <Stack
          justifyContent="center"
          sx={{ width: 1, height: 500, flexGrow: 1, overflowX: 'auto' }}
        >
          {tableData && (
            <>
              <Table
                columnVisibilityConfigKey="merchantPaymentModalColumnVisibilityKey"
                paginationModel={paginationModel}
                hasActiveFilters={hasActiveFilters}
                handleFilterChange={handleFilterChange}
                onPaginationModelChange={handleChangePagination}
                paginationMode="server"
                rowCount={tableData.totalItems}
                // rowCount={tableData?.length}
                className="myTable"
                sx={{
                  width: isDesktop ? 1240 : "auto",
                  height: isDesktop ? "600px" : "auto",
                }}
                isRowSelectable={() => false}
                // disableColumnMenu
                rows={tableData}
                // getRowId={(row) => row.merchantId}
                // rows={tableData || []}
                autoHeight={!isDesktop}
                columns={columns}
                exportFileName="İşyeri Hak Ediş Raporları"
                customLabelDisplayedRows={true}
                onSave={() => onSave()}
              />

            </>
          )}
        </Stack>
        {/* <Button onClick={handleClose}>Close</Button> */}
        <IconButton
          sx={{
            position: "absolute",
            top: 2,
            right: 2,
          }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </Box>
    </Modal>
  );
}
